export interface ICategory {
  id: number;
  code: string;
  name: string;
  source: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  categoryRole: string;
  categoryType: string;
}
